<template>
  <div class="sm:-ml-0 -mb-2 -mt-1 w-full">
    <Alert
      v-if="status === 201"
      type="success"
      title="The 'SparkLayer Dawn Theme' has been successfully added to your Shopify theme library!"
    >
      To get started, go to your
      <a
        :href="themesUrl"
        target="_blank"
        rel="noopener"
        class="font-medium inline-flex items-center text-indigo-600 hover:text-indigo-500"
      >
        <span>Shopify theme library</span>
        <ExternalLinkIcon class="group-hover:text-spark-purple ml-1 h-4 w-4" />
      </a>
      and click the 'Preview' button to see it in action.
    </Alert>
    <Alert
      v-if="status === 422"
      type="warning"
      title="It looks like you've reached your theme limit within Shopify. Please remove a theme and try again."
    />
    <Alert
      v-if="status === 500 || status === 403"
      type="error"
      title="Whoops, an internal issue has occured."
    >
      <div class="text-xs text-red-800">
        You'll need to reconnect your website to SparkLayer to enable our B2B Dawn theme.
        <br>Please
        <router-link
          class="font-medium inline-flex items-center text-indigo-600 hover:text-indigo-500"
          to="/configuration/integrations/platform"
        >
          <span>go to our integrations page</span>
          <ExternalLinkIcon class="group-hover:text-spark-purple h-3 w-3" />
        </router-link>
        and click Save to resolve this.
      </div>
    </Alert>
  </div>
  <Btn
    class="sm:-ml-3 w-full sm:w-auto"
    :loading="loading"
    @click="handleThemeInstall"
  >
    Install the B2B demo theme
  </Btn>
</template>

<script>

import {
  ExternalLinkIcon,
} from '@heroicons/vue/outline';
import { mapGetters } from 'vuex';
import api from '@/utils/api';
import Alert from '@/components/Alert.vue';
import Btn from '@/components/Btn.vue';

export default {
  name: 'ThemeInstallButton',
  components: {
    Btn,
    Alert,
    ExternalLinkIcon,
  },
  emits: ['installed'],
  data() {
    return {
      loading: false,
      status: null,
    };
  },
  computed: {
    ...mapGetters({
      env: 'env/get',
    }),
    themesUrl() {
      if (!(this.env?.shopify_site_url)) {
        return '';
      }
      return `https://${this.env?.shopify_site_url}/admin/themes`;
    },
  },
  methods: {
    async handleThemeInstall() {
      this.loading = true;
      this.status = null;
      try {
        const resp = await api.get('/live/shopify/theme-install');
        this.status = resp.status;
        this.$emit('installed');
        window.Intercom('trackEvent', 'dawn-theme-install', {
          status: 'completed',
        });
      } catch (e) {
        this.status = e.response.status;
        window.Intercom('trackEvent', 'dawn-theme-install', {
          status: (this.status === 500 ? 'errored' : 'theme-limit'),
        });
      }
      this.loading = false;
    },
  },
};
</script>
